import { baseApi } from 'core/api/base'
import { generatePath } from 'react-router'
import { IPrompt, IPromptDetail } from 'core/interfaces/Prompt'
import { APPLICATION_ENDPOINT } from 'core/api/application'

const PROMPTS_ENDPOINT = '/prompts'
const PROMPT_ENDPOINT = `${PROMPTS_ENDPOINT}/:promptId`
const APPLICATION_PROMPTS_ENDPOINT = `${APPLICATION_ENDPOINT}/prompts`
const PROMPT_MULTIPART_ENDPOINT = `${PROMPT_ENDPOINT}/multipart`
const PROMPTS_WITH_DETAILS_ENDPOINT = `${APPLICATION_ENDPOINT}/prompts-details`

const promptApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPromptsWithDetailsFromApplication: builder.query<
      IPromptDetail[],
      { applicationId: number }
    >({
      query: ({ applicationId }) =>
        generatePath(PROMPTS_WITH_DETAILS_ENDPOINT, {
          applicationId: applicationId.toString(),
        }),
    }),
    getPrompt: builder.query<IPrompt, { promptId: number }>({
      query: ({ promptId }) =>
        generatePath(PROMPT_ENDPOINT, {
          promptId: promptId.toString(),
        }),
      providesTags: (result, error, promptId) => [{ type: 'Prompt', promptId }],
    }),
    createPromptMultipart: builder.mutation<
      IPrompt,
      {
        applicationId: number
        data: FormData
      }
    >({
      query: ({ applicationId, data }) => ({
        url: generatePath(APPLICATION_PROMPTS_ENDPOINT, {
          applicationId: applicationId.toString(),
        }),
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result) =>
        result
          ? [
              { type: 'Prompt', id: 'LIST' },
              { type: 'Application', id: result.idApplication },
            ]
          : [{ type: 'Prompt', id: 'LIST' }],
    }),
    updatePromptMultipart: builder.mutation<
      IPrompt,
      {
        promptId: number
        data: FormData
      }
    >({
      query: ({ promptId, data }) => ({
        url: generatePath(PROMPT_MULTIPART_ENDPOINT, {
          promptId: promptId.toString(),
        }),
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result, error, { promptId }) =>
        result
          ? [
              { type: 'Prompt', id: 'LIST' },
              { type: 'Prompt', promptId },
              { type: 'Application', id: result.idApplication },
            ]
          : [{ type: 'Prompt', id: 'LIST' }],
    }),
    deletePrompt: builder.mutation<void, number>({
      query(promptId) {
        return {
          url: generatePath(PROMPT_ENDPOINT, {
            promptId: promptId.toString(),
          }),
          method: 'DELETE',
        }
      },
      invalidatesTags: (result, error, id) => [{ type: 'Prompt', id }],
    }),
  }),
})

export const {
  useGetPromptsWithDetailsFromApplicationQuery,
  useGetPromptQuery,
  useCreatePromptMultipartMutation,
  useUpdatePromptMultipartMutation,
  useDeletePromptMutation,
} = promptApi
export { promptApi }
